export const CLEAR_USER_MANAGEMENT_STATE = 'CLEAR_USER_MANAGEMENT_STATE';

export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_ERROR = 'GET_ALL_USERS_ERROR';

export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_ERROR = 'GET_USER_BY_ID_ERROR';

export const GET_USER_ROLES = 'GET_USER_ROLES';
export const GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS';
export const GET_USER_ROLES_ERROR = 'GET_USER_ROLES_ERROR';

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

export const GET_ALL_ORIGINATORS = 'GET_ALL_ORIGINATORS';
export const GET_ALL_ORIGINATORS_SUCCESS = 'GET_ALL_ORIGINATORS_SUCCESS';
export const GET_ALL_ORIGINATORS_ERROR = 'GET_ALL_ORIGINATORS_ERROR';

export const GET_USER_STATUS = 'GET_USER_STATUS';
export const GET_USER_STATUS_SUCCESS = 'GET_USER_STATUS_SUCCESS';
export const GET_USER_STATUS_ERROR = 'GET_USER_STATUS_ERROR';
